module.exports = __webpack_public_path__ + "85558225b7b5500ddfd76ebd72f2d4d6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/star.svg
// module id = 784
// module chunks = 0